<div class="evaluation-grid" [style.grid-template-columns]="gridTemplateColumns">
  <!--Header Row-->
  <div class="prompt header-row">{{ prompt }}</div>
  @for (option of options; track option; let last = $last) {
    <div class="option header-row" [class.grayed]="last && lastNotSpecified">
      {{ option }}
    </div>
  }

  <!--Rows-->
  @for (row of rows; track row; let rowIndex = $index) {
    <div class="row-prompt" [class.even]="rowIndex % 2 === 0">
      {{ row }}
    </div>
    <mat-radio-group [formControlName]="rowIndex">
      @for (option of options; track option; let optionIndex = $index; let last = $last) {
        <div class="option" [class.even]="rowIndex % 2 === 0" [class.grayed]="last && lastNotSpecified">
          <mat-radio-button
            [attr.aria-label]="option"
            [name]="row"
            [checked]="isChecked(rowIndex, optionIndex)"
            (change)="setValue(rowIndex, optionIndex)"
            [value]="optionIndex"
          ></mat-radio-button>
        </div>
      }
    </mat-radio-group>
  }
</div>
